module.exports = __webpack_public_path__ + "img/3.2c64e978.jpg";